"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var React = _interopRequireWildcard(require("react"));

var _reactHelmet = require("react-helmet");

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _DebugBar = require("./UI/DebugBar");

var _ClientError = require("./UI/ClientError");

var isDevelopment = process.env.NODE_ENV !== 'production';
var isTest = process.env.NODE_ENV === 'test';

if (isTest) {
  // see HotfixHelmetClientDetection
  _reactHelmet.Helmet.canUseDOM = false;
}

function runDidMount(plugins, pluginData) {
  for (var _i = 0, _Object$keys = Object.keys(plugins); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];
    var p = plugins[key];
    var pDidMount = p.didMount;

    if (pDidMount) {
      pDidMount(pluginData[key]);
    }
  }
}

function collectProviders(plugins, pluginData) {
  var result = [];
  var contexts = new Map();

  for (var _i2 = 0, _Object$keys2 = Object.keys(plugins); _i2 < _Object$keys2.length; _i2++) {
    var key = _Object$keys2[_i2];
    var p = plugins[key];

    if (p.Provider) {
      result.push(p.Provider);
      var ctx = React.createContext(pluginData[key]);
      contexts.set(p.Provider, ctx);
    }
  }

  return [result, contexts];
}

var memoizedCollectProviders = (0, _memoizeOne["default"])(collectProviders); // NotePrototype: just for flow

var defaultContext = React.createContext('dynamic-context-failed');

function renderRootProvider(providers, contexts, children) {
  var curEl = children;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = providers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var Provider = _step.value;
      curEl = React.createElement(Provider, {
        ctx: contexts.get(Provider) || defaultContext
      }, curEl);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return curEl;
}

var ErrorBoundary =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(ErrorBoundary, _React$Component);

  function ErrorBoundary(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, ErrorBoundary);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ErrorBoundary).call(this, props));
    _this.state = {
      hasError: false
    };
    return _this;
  }

  (0, _createClass2["default"])(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, info) {
      // Display fallback UI
      this.setState({
        hasError: true
      }); // You can also log the error to an error reporting service

      console.error(error);
      console.info(info);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        var ErrorComponent = this.props.ErrorComponent;
        return React.createElement(ErrorComponent, null);
      }

      return this.props.children;
    }
  }]);
  return ErrorBoundary;
}(React.Component);

var Root =
/*#__PURE__*/
function (_React$Component2) {
  (0, _inherits2["default"])(Root, _React$Component2);

  function Root() {
    (0, _classCallCheck2["default"])(this, Root);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Root).apply(this, arguments));
  }

  (0, _createClass2["default"])(Root, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          pluginData = _this$props.pluginData,
          plugins = _this$props.plugins;
      runDidMount(plugins, pluginData);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          djreactState = _this$props2.djreactState,
          pluginData = _this$props2.pluginData,
          plugins = _this$props2.plugins,
          ErrorComponent = _this$props2.ErrorComponent,
          children = _this$props2.children; // NoteReview(simon): review how context should be instantiated
      // const ctx = memoizedCreateContext(pluginData);

      var _memoizedCollectProvi = memoizedCollectProviders(plugins, pluginData),
          _memoizedCollectProvi2 = (0, _slicedToArray2["default"])(_memoizedCollectProvi, 2),
          providers = _memoizedCollectProvi2[0],
          contexts = _memoizedCollectProvi2[1];

      var rootProviderEl = renderRootProvider(providers, contexts, React.createElement(ErrorBoundary, {
        ErrorComponent: ErrorComponent || _ClientError.ClientError
      }, children));
      return React.createElement(React.Fragment, null, isDevelopment ? React.createElement(_DebugBar.DebugBar, {
        djreactState: this.props.djreactState
      }) : null, React.createElement(_reactHelmet.Helmet, null, React.createElement("html", {
        lang: djreactState.language
      })), rootProviderEl);
    }
  }]);
  return Root;
}(React.Component);

exports.Root = Root;